import { render, staticRenderFns } from "./sfPlan.vue?vue&type=template&id=d53572fe&scoped=true"
import script from "./sfPlan.vue?vue&type=script&lang=js"
export * from "./sfPlan.vue?vue&type=script&lang=js"
import style0 from "./sfPlan.vue?vue&type=style&index=0&id=d53572fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53572fe",
  null
  
)

export default component.exports